import { fetchAccessTokenIfNeeded } from '~/AccessToken';
import { ProductHistoryResult } from '~/Api/Product/History';
import { findUserGroupProductsHistory } from '~/Api/User/ProductGroup/ProductHistory';
import { invokeApi, resolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { selectEventsByGroupId, State } from './reducer';

export function fetchGroupProductHistory(
	groupId: string,
	page = 1,
	perPage = 100
): ThunkAction<Promise<ProductHistoryResult>, any> {
	return async (dispatch) => {
		const userId = (await dispatch(fetchAccessTokenIfNeeded())).accessToken.user.id;
		const request = dispatch(invokeApi(findUserGroupProductsHistory, userId, groupId, page, perPage));
		dispatch({ type: ActionTypes.request, request, groupId });

		return resolve(request, (response) =>
			dispatch({
				type: ActionTypes.receive,
				request,
				groupId,
				events: response?.items || null,
				pagination: response?.pagination || null,
			})
		);
	};
}

export function fetchMoreGroupProductHistory(groupId: string): ThunkAction<Promise<ProductHistoryResult | null>, any> {
	return async (dispatch, getState) => {
		const events = selectEventsByGroupId(getState().groupProductHistory, groupId);
		if (!events || !events.pagination) {
			return dispatch(fetchGroupProductHistory(groupId));
		}

		const nextPage = events.pagination?.getNextPage();
		if (nextPage === null || nextPage === undefined) {
			return null;
		}

		return dispatch(fetchGroupProductHistory(groupId, nextPage));
	};
}

export function pruneGroupProductHistory(groupId: string): { type: string; groupId: string } {
	return { type: ActionTypes.prune, groupId };
}
